

































































































import {
    Component,
    Prop,
    Vue,
    Emit,
    Model,
    Watch,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';

import axios from 'axios';

@Component({
    components: {},
})
export default class UpdateTaskForm extends Vue {

    @Prop({
        type: Boolean,
        default: false,
    })
    private visible!: boolean;

    @Prop({
        type: Object,
        default() {
            return {};
        },
    })
    private record!: any;

    private form: any = null;

    private formVals: any = {
        target: '0',
        template: '0',
        type: '1',
        time: '',
        frequency: 'month',
    };

    private currentStep: number = 0;

    private formLayout = {
        labelCol: {
            span: 7,
        },
        wrapperCol: {
            span: 13,
        },
    };

    private handleBackward(): void {
        this.currentStep--;
    }

    private handleNext(): void {
        this.form.validateFields((err: any, fieldsValue: any) => {
            if (err) {
                return;
            }
            this.formVals = { ...this.formVals, ...fieldsValue };
            this.currentStep++;
        });
    }

    private handleCancel(): void {
        this.updateVisible(false);
    }

    private handleOk(): void {

        this.form.validateFields((err: any, fieldsValue: any) => {
            if (err) {
                return;
            }
            this.formVals = { ...this.formVals, ...fieldsValue };

            axios.post('/updateRule', {...this.formVals})
                .then(() => {
                    this.updateVisible(false);
                    this.onOk();
                });
            });

    }

    @Emit('ok')
    private onOk() {

    }

    private updateVisible(visible: boolean): void {
        this.$emit('update:visible', visible);
    }

    private mounted(): void {
        this.currentStep = 0;
    }

    @Watch('record', {
        immediate: true,
        deep: true,
    })
    private recordChange(value: any, oldValue: any): void {
        this.formVals = {
            ...value,
            ...this.formVals,
        };
        this.currentStep = 0;
    }

}
